import { isEngineOilOutdated } from '@/features/engineoil/utils/utils';
import type { EngineOilFleetItem, EngineOilRow } from './types';

export const mapToRow = (item: EngineOilFleetItem): EngineOilRow => {
    const timestamp = item.measured_at?.date;
    const measurement = item.measurement ?? null;
    const isReadingNotPossible = isEngineOilOutdated(timestamp);

    return {
        id: item.asset_id,
        assetId: item.asset_id ?? '',
        vehicleName: item.name ?? '',
        vin: item.vin ?? '',
        workshop: item.workshop ?? '',
        workshopId: item.workshop_id ?? '',
        customer: item.customer ?? '',
        state: item.state,
        status: item.status,
        measurement,
        timestamp,
        mileage: item.measured_at?.mileage_km,
        activeDtc: item.active_dtc ?? null,
        isReadingNotPossible,
    };
};

export const mapToRows = (list: EngineOilFleetItem[]): EngineOilRow[] => list.map(mapToRow);
